import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/Index'
import claimDetail from '@/components/claimDetail'
import claimFlow from '@/components/ClaimFlow'
import claimList from '@/components/ClaimList'
import claimStep1 from '@/components/ClaimStep1'
import claimStep2 from '@/components/ClaimStep2'
import claimSuccess from '@/components/ClaimSuccess'
import create from '@/components/create'
import createSuccess from '@/components/createSuccess'
import docs from '@/components/docs'
import protocol from '@/components/protocol'
import protocolIos from '@/components/protocolIos'
import protocolIvvi from '@/components/protocolIvvi'
import protocolA0009 from '@/components/protocolA0009'
import range from '@/components/range'
import rangeIos from '@/components/rangeIos'
import rangeIvvi from '@/components/rangeIvvi'
import rangeA0009 from '@/components/rangeA0009'
import * as trace from '../lib/Utils/trace.js'
// import NEW from './new'


// 商户
import newINDEX from '@/views/home'
import newcreateStore from '@/views/createStore'
import newcreateSuccess from '@/views/createSuccess'
import newdetail from '@/views/detail'
import newinsureDetail from '@/views/insureDetail'
import newwifiSelect from '@/views/wifiSelect/index'
import newrange from '@/views/range'
import newrangePersonal from '@/views/rangePersonal'
import newclaimStep1 from '@/views/claimStep1'
import newclaimStep2 from '@/views/claimStep2'
import newclaimSuccess from '@/views/claimSuccess'
import newdocs from '@/views/docs'
import newclaimFlow from '@/views/claimFlow'
import newclaimList from '@/views/claimList'
import newclaimDetail from '@/views/claimDetail'
import newprotocol from '@/views/protocol'
import newprotocolIos from '@/views/protocolIos'
import newfindMac from '@/views/docs/findMac'
import newisShare from '@/views/docs/isShare'

const bucket = '/new'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi安全险'
        trace.enterTrace({page: 1})
        trace.enterTrace({page: 2})
        next()
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi安全险'
        trace.enterTrace({page: 1})
        trace.enterTrace({page: 2})
        next()
      }
    },
    {
      path: '/claimDetail',
      name: 'claimDetail',
      component: claimDetail,
      beforeEnter: (to, from, next) => {
        document.title = '索赔详情'
        trace.enterTrace({page: 3})
        next()
      }
    },
    {
      path: '/claimFlow',
      name: 'claimFlow',
      component: claimFlow,
      beforeEnter: (to, from, next) => {
        document.title = '索赔流程'
        next()
      }
    },
    {
      path: '/claimList',
      name: 'claimList',
      component: claimList,
      beforeEnter: (to, from, next) => {
        document.title = '索赔记录'
        trace.enterTrace({page: 8})
        next()
      }
    },
    {
      path: '/claimStep1',
      name: 'claimStep1',
      component: claimStep1,
      beforeEnter: (to, from, next) => {
        document.title = '用户索赔登记'
        trace.enterTrace({page: 7, step: 1})
        next()
      }
    },
    {
      path: '/claimStep2',
      name: 'claimStep2',
      component: claimStep2,
      beforeEnter: (to, from, next) => {
        document.title = '用户索赔登记',
        trace.enterTrace({page: 7, step: 2})
        next()
      }
    },
    {
      path: '/claimSuccess',
      name: 'claimSuccess',
      component: claimSuccess,
      beforeEnter: (to, from, next) => {
        document.title = '索赔登记成功'
        next()
      }
    },
    {
      path: '/create',
      name: 'create',
      component: create,
      beforeEnter: (to, from, next) => {
        document.title = '个人参保'
        trace.enterTrace({page: 4})
        next()
      }
    },
    {
      path: '/createSuccess',
      name: 'createSuccess',
      component: createSuccess,
      beforeEnter: (to, from, next) => {
        document.title = '参保成功'
        next()
      }
    },
    {
      path: '/docs',
      name: 'docs',
      component: docs,
      beforeEnter: (to, from, next) => {
        document.title = '索赔所需资料'
        next()
      }
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: protocol,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi万能钥匙用户安全保险协议'
        trace.enterTrace({page: 5, type: 'protocol'})
        next()
      }
    },
    {
      path: '/protocolIos',
      name: 'protocolIos',
      component: protocolIos,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi万能钥匙用户安全保险协议'
        trace.enterTrace({page: 5, type: 'protocolIos'})
        next()
      }
    },
    {
      path: '/protocolIvvi',
      name: 'protocolIvvi',
      component: protocolIvvi,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi万能钥匙用户安全保险协议'
        trace.enterTrace({page: 5, type: 'protocolIvvi'})
        next()
      }
    },
    {
      path: '/protocolA0009',
      name: 'protocolA0009',
      component: protocolA0009,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi万能钥匙用户安全保险协议'
        trace.enterTrace({page: 5, type: 'protocolA0009'})
        next()
      }
    },
    {
      path: '/range',
      name: 'range',
      component: range,
      beforeEnter: (to, from, next) => {
        document.title = '保障范围'
        trace.enterTrace({page: 6, type: 'range'})
        next()
      }
    },
    {
      path: '/rangeIos',
      name: 'rangeIos',
      component: rangeIos,
      beforeEnter: (to, from, next) => {
        document.title = '保障范围'
        trace.enterTrace({page: 6, type: 'rangeIos'})
        next()
      }
    },
    {
      path: '/rangeIvvi',
      name: 'rangeIvvi',
      component: rangeIvvi,
      beforeEnter: (to, from, next) => {
        document.title = '保障范围'
        trace.enterTrace({page: 6, type: 'rangeIvvi'})
        next()
      }
    },
    {
      path: '/rangeA0009',
      name: 'rangeA0009',
      component: rangeA0009,
      beforeEnter: (to, from, next) => {
        document.title = '保障范围'
        trace.enterTrace({page: 6, type: 'rangeA0009'})
        next()
      }
    },
    {
      // 首页
      path: `${bucket}`,
      name: `${bucket}`,
      component: newINDEX,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi安全险'
        next()
      }
    },
    {
      // 首页
      path: `${bucket}/home`,
      name: `${bucket}/home`,
      component: newINDEX,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi安全险'
        next()
      }
    },
    {
      // 投保
      path: `${bucket}/createStore`,
      name: `${bucket}/createStore`,
      meta: {
        keepAlive: true // 代码中有业务缓存逻辑、路径path改变需谨慎。
      },
      component: newcreateStore,
      beforeEnter: (to, from, next) => {
        document.title = '商户参保'
        next()
      }
    },
    {
      // wifi选择列表
      path: `${bucket}/wifiSelect`,
      name: `${bucket}/wifiSelect`,
      component: newwifiSelect,
      beforeEnter: (to, from, next) => {
        document.title = '选择WiFi'
        next()
      }
    },
    {
      // 个人投保详情
      path: `${bucket}/detail`,
      name: `${bucket}/detail`,
      component: newdetail,
      beforeEnter: (to, from, next) => {
        document.title = '投保详情'
        next()
      }
    },
    {
      // 商家投保详情
      path: `${bucket}/insureDetail`,
      name: `${bucket}/insureDetail`,
      component: newinsureDetail,
      beforeEnter: (to, from, next) => {
        document.title = '投保详情'
        next()
      }
    },
    {
      // 投保成功
      path: `${bucket}/createSuccess`,
      name: `${bucket}/createSuccess`,
      component: newcreateSuccess,
      beforeEnter: (to, from, next) => {
        document.title = '参保成功'
        next()
      }
    },
    {
      // WiFi万能钥匙商户热点安全理赔计划
      path: `${bucket}/range`,
      name: `${bucket}/range`,
      component: newrange,
      beforeEnter: (to, from, next) => {
        document.title = '保障范围'
        next()
      }
    },
    {
      path: `${bucket}/rangePersonal`,
      name: `${bucket}rangePersonal`,
      component: newrangePersonal,
      beforeEnter: (to, from, next) => {
        document.title = '保障范围'
        next()
      }
    },
    {
      // 理赔步骤1
      path: `${bucket}/claimStep1`,
      name: `${bucket}/claimStep1`,
      component: newclaimStep1,
      beforeEnter: (to, from, next) => {
        document.title = '用户索赔登记'
        next()
      }
    },
    {
      // 理赔步骤2
      path: `${bucket}/claimStep2`,
      name: `${bucket}/claimStep2`,
      component: newclaimStep2,
      beforeEnter: (to, from, next) => {
        document.title = '用户索赔登记'
        next()
      }
    },
    {
      // 
      path: `${bucket}/claimSuccess`,
      name: `${bucket}/claimSuccess`,
      component: newclaimSuccess,
      beforeEnter: (to, from, next) => {
        document.title = '索赔登记成功'
        next()
      }
    },
    {
      // 
      path: `${bucket}/claimFlow`,
      name: `${bucket}/claimFlow`,
      component: newclaimFlow,
      beforeEnter: (to, from, next) => {
        document.title = '索赔流程'
        next()
      }
    },
    {
      // 
      path: `${bucket}/docs`,
      name: `${bucket}/docs`,
      component: newdocs,
    },
    {
      // 索赔列表
      path: `${bucket}/claimList`,
      name: `${bucket}/claimList`,
      component: newclaimList,
      beforeEnter: (to, from, next) => {
        document.title = '索赔记录'
        next()
      }
    },
    {
      // 索赔详情
      path: `${bucket}/claimDetail`,
      name: `${bucket}/claimDetail`,
      component: newclaimDetail,
      beforeEnter: (to, from, next) => {
        document.title = '索赔详情'
        next()
      }
    },
    {
      // 
      path: `${bucket}/protocol`,
      name: `${bucket}/protocol`,
      component: newprotocol,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi万能钥匙用户安全保险协议'
        next()
      }
    },
    {
      // 
      path: `${bucket}/protocolIos`,
      name: `${bucket}/protocolIos`,
      component: newprotocolIos,
      beforeEnter: (to, from, next) => {
        document.title = 'WiFi万能钥匙用户安全保险协议'
        next()
      }
    },
    {
      // 找回mac
      path: `${bucket}/findMac`,
      name: `${bucket}/findMac`,
      component: newfindMac,
      beforeEnter: (to, from, next) => {
        document.title = '如何找到MAC地址'
        next()
      }
    },
    {
      // 是否分享
      path: `${bucket}/isShare`,
      name: `${bucket}/isShare`,
      component: newisShare,
      beforeEnter: (to, from, next) => {
        document.title = '如何查看是否分享'
        next()
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js